<div
  class="resize-handle"
  aria-label="Resize drawer"
  role="separator"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="60" viewBox="0 0 2 60" fill="none">
    <path d="M1 1V59" stroke="currentColor" stroke-linecap="round" />
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="60" viewBox="0 0 2 60" fill="none">
    <path d="M1 1V59" stroke="currentColor" stroke-linecap="round" />
  </svg>

</div>
